import React from "react";
import { Link } from "react-router-dom";
import { LayoutGrid, Workflow, LineChart, Sparkles, ArrowUpRight, Check } from "lucide-react";
import { useSiteContent } from "../data/content";

const ICONS = { LayoutGrid, Workflow, LineChart, Sparkles };

export default function Services() {
  const content = useSiteContent();
  const ui = content.ui.services;
  return (
    <section id="leistungen" className="py-24 lg:py-32 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-[12px] font-medium tracking-[0.2em] uppercase text-teal-700">
            {ui.eyebrow}
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-[#0B1F3A] leading-[1.1]">
            {ui.titleLine1}
            <br />
            <span className="text-slate-500">{ui.titleLine2}</span>
          </h2>
          <p className="mt-6 text-slate-600 text-[17px] leading-relaxed">{ui.intro}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5">
          {content.services.map((s, i) => {
            const Icon = ICONS[s.icon] || LayoutGrid;
            return (
              <Link
                key={s.title}
                to={`/leistungen/${s.slug}`}
                className="group relative bg-white rounded-2xl p-8 border border-slate-200 hover:border-slate-300 hover:shadow-xl hover:shadow-slate-900/5 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 block"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl bg-[#0B1F3A] text-white flex items-center justify-center shadow-lg shadow-slate-900/10">
                    <Icon className="w-6 h-6" />
                  </div>
                  <span className="text-xs font-mono text-slate-400">0{i + 1}</span>
                </div>
                <h3 className="mt-6 text-2xl font-semibold text-[#0B1F3A] tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.desc}</p>
                <ul className="mt-5 space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-slate-700">
                      <Check className="w-4 h-4 text-teal-600" />
                      {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#0B1F3A] group-hover:text-teal-700 transition-colors duration-300">
                  {content.ui.learnMore}
                  <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
